module.exports = __webpack_public_path__ + "static/media/pendientes icon.7306f544.svg";